import {
  CredentialBlockType,
  CredentialStatus,
  CredentialType,
  type ICredential,
  type ICredentialBlock,
} from '@commenda/types/src/credential/types';
import { toTitleCaseSentence } from '@commenda/utils';
import type { Country } from '@prisma/client';

import {
  IndirectTaxCredentialBlockType,
  type IIndirectTaxCredentialWithPortal,
} from './types';

function mapBlockType(bt: IndirectTaxCredentialBlockType): CredentialBlockType {
  return bt === IndirectTaxCredentialBlockType.SecureString
    ? CredentialBlockType.SecureString
    : CredentialBlockType.PlainText;
}

export function normalizeIndirectTaxCredential(cred: IIndirectTaxCredentialWithPortal): ICredential {
  const rawName = cred.name || cred.portalDetails?.portalName || '';

  const blocks: ICredentialBlock[] = (cred.blocks || []).map((b) => ({
    id: b.id,
    key: b.blockLabel,
    type: mapBlockType(b.blockType),
    value: b.value,
    secretMask: null,
    isCustomBlock: false,
  }));

  return {
    id: cred.id,
    name: toTitleCaseSentence(rawName),
    credentialType: CredentialType.INDIRECT_TAX,
    country: (cred.portalDetails?.country ?? '') as Country,
    jurisdiction: cred.portalDetails?.stateOrProvince || null,
    status: cred.status as unknown as CredentialStatus,
    updatedAt: new Date(cred.updatedAt),
    createdAt: new Date(cred.createdAt),
    lastUpdatedAt: cred.updatedAt,
    notes: cred.notes || '',
    portalURL: cred.portalDetails?.portalUrl || cred.portalUrl || '',
    isCustom: false,
    internalIdentifier: '',
    blocks,
    isUsed: true,
    registrations: [],
  };
}
